import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { UxError } from 'src/app/models/ux-error.model';
import {
  KnowledgeAttentionSection,
  KnowledgeRecentEntityItem,
} from 'src/app/models/home/knowledge-attention/knowledge-attention.model';
import { LanguageService } from 'src/app/services/language/language.service';

/**
 * Home IA · Radar de conocimiento R4 (K6). Widget "Entidades con actividad reciente": top-N de
 * entidades R4 (nombre, tipo, última actividad, nº de fuentes visibles) con deep-link a
 * `/knowledge/entidades`. READ-ONLY. Se oculta si el plan no tiene `knowledge_hub`. Degrada de
 * forma independiente del widget de vencimientos (usa su propio `section.status`).
 */
@Component({
  selector: 'app-home-knowledge-entities',
  templateUrl: './home-knowledge-entities.component.html',
  styleUrls: ['./home-knowledge-entities.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HomeKnowledgeEntitiesComponent {
  @Input() section: KnowledgeAttentionSection<KnowledgeRecentEntityItem> | null = null;
  @Input() featureAvailable = false;
  @Input() loading = false;
  @Input() error: UxError | null = null;
  @Output() retryRequest = new EventEmitter<void>();

  readonly knowledgeLink = '/knowledge/entidades';

  constructor(public lang: LanguageService) {}

  get items(): KnowledgeRecentEntityItem[] {
    return this.section?.items ?? [];
  }

  get hasError(): boolean {
    return !!this.error || this.section?.status === 'error';
  }

  get isEmpty(): boolean {
    return !this.loading && !this.hasError && (this.section?.status === 'empty' || this.items.length === 0);
  }

  onRetry(): void {
    this.retryRequest.emit();
  }
}
